// Centralized API configuration
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080/api';
const API_KEY = process.env.REACT_APP_API_KEY || '';

// Debug logging
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 API Configuration:', {
    baseUrl: API_BASE_URL,
    hasApiKey: !!API_KEY
  });
}

export { API_BASE_URL, API_KEY };
export default API_BASE_URL;